import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDropdown]',
  standalone: true
})
export class DropdownDirective {
  private isOpen = false;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @HostListener('click')
  toggleOpen() {
    this.isOpen = !this.isOpen;
    this.updateClasses();
  }

  @HostListener('document:click', ['$event.target'])
  closeIfClickedOutside(target: HTMLElement) {
    const clickedInside = this.el.nativeElement.contains(target);
    if (!clickedInside && this.isOpen) {
      this.isOpen = false;
      this.updateClasses();
    }
  }

  private updateClasses() {
    const toggle = this.el.nativeElement.querySelector('.dropdown-toggle');
    const menu = this.el.nativeElement.querySelector('.dropdown-menu');

    if (this.isOpen) {
      this.renderer.addClass(toggle, 'show');
      this.renderer.addClass(menu, 'show');
    } else {
      this.renderer.removeClass(toggle, 'show');
      this.renderer.removeClass(menu, 'show');
    }
  }

}
